import React from "react";

export default function SectionBlock({ data }) {
  return (
    <div style={{ padding: "25px", background: "#222", borderRadius: "12px", color: "white", marginTop: "20px" }}>
      <h2 style={{ marginBottom: "15px" }}>
        {data.title || "Section Title"}
      </h2>

      <div
        dangerouslySetInnerHTML={{
          __html: data.content || "<p>Section content goes here...</p>",
        }}
      />
    </div>
  );
}
